import { z } from 'zod';
import { SubscriptionInterval } from './subscription-interval';

export const SubscriptionAddonNameSchema = z.enum([ 'credits-200', 'credits-500', 'domains-1', 'domains-5' ]);
export const OneOffAddonNameSchema = z.enum(['starter-audit']);

export type SubscriptionAddonName = z.infer<typeof SubscriptionAddonNameSchema>;
export type OneOffAddonName = z.infer<typeof OneOffAddonNameSchema>;

export type SubscriptionAddonWithInterval = `${SubscriptionAddonName}.${SubscriptionInterval}`;

export type AddonName = OneOffAddonName | SubscriptionAddonName;
export type PurchasableAddonName = OneOffAddonName | SubscriptionAddonWithInterval;

export const isSubscriptionAddon = (name: string): name is SubscriptionAddonName => {
    return SubscriptionAddonNameSchema.safeParse(name).success;
}

export const isOneOffAddon = (name: string): name is OneOffAddonName => {
    return OneOffAddonNameSchema.safeParse(name).success;
};